import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import isEqual from 'lodash.isequal';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { Ul, Li } from '../components/Markdown';
import { useToast } from '../components/Toast';
import { CREATE_CHECKOUT_SESSION } from '../utilities/mutations';
import nightTheme from '../themes/night';
import PlusAsset from '../assets/plus.png';
import PlusLightAsset from '../assets/plus-light.png';

const UpgradeModal = () => {
  const toast = useToast();
  const params = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [createCheckoutSession] = useMutation(CREATE_CHECKOUT_SESSION, {
    variables: { spaceSlug: params.s },
  });

  return (
    <Modal onClose={() => navigate(`/s/${params.s}/settings/plan`)}>
      <ModalName>Upgrade to Plus</ModalName>
      <ModalPart>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {isEqual(theme, nightTheme) ? (
            <img src={PlusLightAsset} width={130} />
          ) : (
            <img src={PlusAsset} width={130} />
          )}
        </div>
        <Ul>
          <Li>Customize your space with a banner</Li>
          <Li>Invite up to 10 users</Li>
          <Li>Create up to 30 tags</Li>
          <Li>Create up to 1000 topics</Li>
        </Ul>
      </ModalPart>
      <ModalPart>
        <Button
          disabled={loading}
          isPrimary
          isExtended
          onClick={async () => {
            try {
              setLoading(true);

              const data = await createCheckoutSession();

              window.location.replace(data.data.createCheckoutSession);

              setLoading(false);
            } catch (error) {
              setLoading(false);

              toast({ children: error.message });
            }
          }}
        >
          $5.99 / month
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default UpgradeModal;
